export const formatToNumber = currency => {
    let currencyToNumber = currency.toString().replace(/£/g, '').replace(/,/g, '');
    currencyToNumber = isNaN(parseInt(currencyToNumber)) ? '' : parseInt(currencyToNumber);
    return currencyToNumber;
};
